import '@fortawesome/fontawesome-free/css/all.css';
import 'ionicons/css/ionicons.min.css';
import 'react-datepicker/dist/react-datepicker.css';
import 'react-pdf/dist/Page/AnnotationLayer.css';
import React from 'react';
import { createRoot } from 'react-dom/client';
import ReactApp from './app/ReactApp';

// include OIDC client in React bundle (sets window.getUserManager)
import './services/oidcClient';

const rootEl = document.getElementById('root');
if (!rootEl) {
  throw new Error('Missing #root element — cannot mount Ministry Grid');
}

createRoot(rootEl).render(<ReactApp />);
